// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28H8X","col":"styles_col__1CB3t"};